import ACTIONS from '@/store/storeActions'

const actions = {
  [ACTIONS.SET_RUN_INFO]: (context, payload) => {
    context.commit(ACTIONS.SET_RUN_INFO, payload);
  },
  [ACTIONS.SET_CANDIDATE_STATUS]: (context, payload) => context.commit(ACTIONS.SET_CANDIDATE_STATUS, payload),
  [ACTIONS.SET_CANDIDATE_RUN_INFO]: (context, payload) => context.commit(ACTIONS.SET_CANDIDATE_RUN_INFO, payload),
  [ACTIONS.SET_RUN_STATE]: (context, payload) => {
    context.commit(ACTIONS.SET_RUN_STATE, payload)
  },
  [ACTIONS.UPDATE_RUN_STATE]: (context, payload) => {
    context.commit(ACTIONS.UPDATE_RUN_STATE, payload);
  },
  [ACTIONS.SET_RUN_INFO_LOADINGSTATE]: (context, payload) => {
    context.commit(ACTIONS.SET_RUN_INFO_LOADINGSTATE, payload);
  },
  [ACTIONS.SET_CURRENT_EXERCISE]: (context, payload) => {
    context.commit(ACTIONS.SET_CURRENT_EXERCISE, payload);
  },
  [ACTIONS.SET_CANDIDATE_EXERCISE_STATUS_LOADINGSTATE]: (context, payload) => {
    context.commit(ACTIONS.SET_CANDIDATE_EXERCISE_STATUS_LOADINGSTATE, payload)
  },
  [ACTIONS.SET_OPEN_EXERCISE_ID]: (context, payload) => {
    context.commit(ACTIONS.SET_OPEN_EXERCISE_ID, payload)
  },
  [ACTIONS.SET_RUN_DOCUMENTS]: (context, payload) => {
    context.commit(ACTIONS.SET_RUN_DOCUMENTS, payload);
  }
}

export default actions
